export const actions = {
  async getAdreses(state) {
    const res = await this.$axios.get('/profile/addresses')
    return res.data
  },
  async getProfile(state) {
    const res = await this.$axios.get('/profile/user')
    return res.data
  },
  async getPageAuth(state) {
    const res = await this.$axios.get('/pages/auth')
    return res.data
  },

  async updateProfile(state, data) {
    const res = await this.$axios.put('/profile/user', data)
    return res.data
  },

  async resetPassword(state, data) {
    const res = await this.$axios.put('/profile/user/password', data)
    return res.data
  },
  async recoverPassword(state, data) {
    const res = await this.$axios.post('/recover', data)
    return res.data
  },
  async resetPassword2(state, data) {
    const res = await this.$axios.post('/reset', data)
    return res.data
  },
  async getAddress(state) {
    const res = await this.$axios.get('/profile/addresses')
    return res.data
  },

  async addAddress(state, data) {
    const res = await this.$axios.post('/profile/addresses', data)
    return res.data
  },

  async editAddress(state, data) {
    const res = await this.$axios.put('/profile/addresses/' + data.id, data)
    return res.data
  },

  async getAllRegions(state, data) {
    const res = await this.$axios.get('/regions', data)
    return res.data
  },

  async getDistricts(state, data) {
    const res = await this.$axios.get('/regions/' + data + '/communes')
    return res.data
  },

  async deleteAddress(state, data) {
    const res = await this.$axios.delete('/profile/addresses/' + data)
    return res.data
  },
  async getPurchases(state) {
    const res = await this.$axios.get('profile/purchases')
    return res.data
  },
  async getPurchase(state, data) {
    const res = await this.$axios.get('profile/purchases/' + data)
    return res.data
  },
}
